




import Vue from 'vue';

import handleLayoutComponent from './components/common/handle-layout.component.vue';

export default Vue.extend({
  name: 'App',
  components: { handleLayoutComponent },
});
